<template>
  <v-container>
    <v-layout text-xs-center wrap>
      <v-flex xs12>
        <v-img
          :src="require('../assets/logo.png')"
          class="my-3"
          contain
          height="60"
        ></v-img>
      </v-flex>

      <v-flex mb-4 xs12>
        <h1 class="display-2 font-weight-bold mb-3">DataPlan Import/Export</h1>
        <p class="subheading font-weight-regular">
          Mit dieser Anwendung können Zählerstände aus ELEMENT IoT zu DataPlan exportiert
          werden. Es wird ein gültiger API-Key benötigt und es muss ein Ordner mit den zu
          exportierenden Zählern angegeben werden.
        </p>
      </v-flex>

      <v-flex mb-5 xs12>
        <h2 class="headline font-weight-bold mb-3">Einstellungen</h2>

        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="baseURL"
            label="ELEMENT Base URL"
            required
            @change="loadFolders"
          ></v-text-field>

          <v-text-field
            v-model="apikey"
            :counter="32"
            :rules="apikeyRules"
            label="ELEMENT API Schlüssel"
            required
          ></v-text-field>

          <v-autocomplete
            v-model="folder"
            :items="folders"
            item-text="name"
            item-value="slug"
            label="ELEMENT Ordner"
            persistent-hint
            return-object
            single-line
            required
            :disabled="folders.length == 0"
            :loading="loading"
          ></v-autocomplete>

          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateFormatted"
                label="Spätestes Ablesedatum vor dem"
                hint="DD.MM.YYYY"
                persistent-hint
                prepend-icon="event"
                @blur="date = parseDate(dateFormatted)"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" no-title @input="menu = false"></v-date-picker>
          </v-menu>

          <v-btn
            color="primary"
            @click="getDevices"
            :disabled="folder == null"
            :loading="readingsLoading"
            >Datei erzeugen</v-btn
          >
          <v-btn :disabled="blob == null" @click="saveFile">Datei herunterladen</v-btn>
        </v-form>
      </v-flex>
      <!--<v-flex xs12>
        <label for="file-upload" class="v-card v-sheet theme--dark green mt-5 pa-3">
                Export-Datei auswählen
            </label>
            <input v-show="true" id="file-upload" type="file" @change="inputFileChanged" >
      </v-flex>
      <v-flex xs12>
            <v-card class="mt-2 pa-1">
              <div v-if="file">Datei ausgewählt: {{file.name}}</div>
              <div v-else>
                Keine Datei ausgewählt
              </div>
        </v-card>
      </v-flex>
        <code v-if="fileContent && errors == null">{{ JSON.stringify(fileContent, null, 2)}}</code>
      <code v-if="errors">{{ JSON.stringify(errors, null, 2)}}</code>-->
    </v-layout>
  </v-container>
</template>

<script>
//import Papa from 'papaparse'
import axios from "axios";
import rateLimit from "axios-rate-limit";
import { Promise } from "q";
import { saveAs } from "file-saver";
//import { saveAs } from "file-saver"
const http = rateLimit(axios.create(), {
  maxRequests: 50,
  perMilliseconds: 10000,
});
const getQueryStringParams = (query) => {
  return query
    ? (/[?#]/.test(query) ? query.split(/[?#]/)[1] : query)
        .split("&")
        .reduce((params, param) => {
          let [key, value] = param.split("=");
          params[key] = value ? decodeURIComponent(value.replace(/\+/g, " ")) : "";
          return params;
        }, {})
    : {};
};

export default {
  data: (vm) => ({
    valid: true,
    baseURL:
      getQueryStringParams(window.location.href)["base_url"] || "https://element-iot.com",
    apikey: getQueryStringParams(window.location.href)["apikey"] || "",
    apikeyRules: [
      (v) => !!v || "API Schlüssel ist ein Pflichtfeld",
      (v) => (v && v.length == 32) || "API Schlüssel muss 32 Zeichen haben",
    ],
    // file: null,
    // fileContent: null,
    errors: null,
    folders: [],
    folder: null,
    loading: false,
    readingsLoading: false,
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu: false,
    blob: null,
    //outLines: []
    //errorLines: []
  }),
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(val);
    },
    apikey: function (val) {
      if (val.length === 32) {
        this.getFolders();
      } else {
        this.folders = [];
      }
    },
  },
  mounted: function () {
    this.getFolders();
  },
  methods: {
    loadFolders() {
      if (this.apikey && this.apikey.length === 32) {
        this.getFolders();
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    setBlob: function (values) {
      this.blob = new Blob(values, { type: "text/csv;charset=utf-8" });
    },
    saveFile: function () {
      saveAs(this.blob, "export_" + this.date + ".csv");
    },
    loadAll: function (url, after_id, with_profile) {
      return http
        .get(url, {
          params: {
            auth: this.apikey,
            limit: 100,
            retrieve_after: after_id || undefined,
            with_profile: with_profile || undefined,
          },
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          //responseType: 'text'
        })
        .then((r) => {
          if (r.data != null && r.data.body != null && r.status == 200) {
            if (r.data.retrieve_after_id) {
              return this.loadAll(
                url,
                r.data.retrieve_after_id,
                with_profile
              ).then((list) => list.concat(r.data.body));
            } else {
              return r.data.body;
            }
          } else return Promise.reject();
        });
    },
    getFolders: function () {
      if (!!this.apikey && this.apikey.length === 32) {
        this.loading = true;
        this.loadAll(this.baseURL + "/api/v1/tags")
          .then((folders) => {
            this.$set(this, "folders", folders);
            var queryFolder = getQueryStringParams(window.location.href)["folder"];
            if (queryFolder != null) {
              var folder = this.folders.find((f) => {
                return f.slug != null && f.slug == queryFolder;
              });
              if (typeof folder !== "undefined") {
                this.$set(this, "folder", folder);
              }
            }
          })
          .catch((error) => {
            // handle error
            // eslint-disable-next-line
            console.log(error);
            this.$set(this, "folders", []);
          })
          .finally(() => (this.loading = false));
      }
    },
    getReading: async function (device) {
      try {
        const r = await axios.get(
          this.baseURL + "/api/v1/devices/" + device.slug + "/readings",
          {
            params: {
              auth: this.apikey,
              limit: 1,
              before: this.date,
              filter: "data.value_1 != null || data.value_m3 != null",
            },
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        const { name } = device;
        let {
          data: {
            body: [
              {
                data: { value_m3, value_1 },
                measured_at,
              },
            ],
          },
        } = r;
        [measured_at] = measured_at.split("T");
        let [year, month, day] = measured_at.split("-");
        measured_at = `${day}.${month}.${year}`;
        value_m3 = Number((value_1 / 1000 || value_m3).toFixed(4));
        let line = [name, measured_at, value_m3].join(";");
        return line + "\n";
      } catch (error) {
        if (error.response && error.response.status === 429) {
          // eslint-disable-next-line
          console.log("Retry ...");
          return new Promise((resolve) => {
            setTimeout(() => resolve(this.getReading(device)), 5000);
          });
        } else {
          return device.name + "\n";
        }
      }
    },
    getDevices: async function () {
      this.readingsLoading = true;
      let devices = await this.loadAll(
        this.baseURL + "/api/v1/tags/" + this.folder.slug + "/devices",
        undefined,
        1
      ).then((r) => {
        return r.map((device) => {
          const { slug, id, name } = device;
          return {
            slug,
            id,
            name,
          };
        });
      });
      const lines = ["znr;abl_dat;abl_stand\n"];
      for (const d of devices) {
        const r = await this.getReading(d);
        lines.push(r);
      }
      // eslint-disable-next-line
      console.log("saving ...");
      this.setBlob(lines);
      this.readingsLoading = false;
    },
    inputFileChanged: function (event) {
      this.file = event.target.files[0];
    },
  },
};
</script>

<style>
input[type="file"] {
  display: none;
}
</style>
